<template>
    <div class="text-dark text-center mt-5 small mb-3">
    Powered by | <strong>Proba Workflows</strong>
    </div>
</template>
<script>
    export default{
        name:'AiFooter'
    }
</script>